import React, { useMemo } from 'react'
import styled, { css } from 'styled-components'
import { FontAwesomeIcon, CSSCursor } from '../types/css'
import { BaseProps } from '../types/props'
import { getIconTypeClassName } from './util'
import { overloadColor } from '../util/style'

interface IProps {
  color: string
  hoverColor?: string
  opacity: number
  hoverOpacity?: number
  cursor: string

  size: string
  margin: string
  translateX?: string
  translateY?: string
}
const I = styled.i<IProps>`
  margin: ${props => props.margin};
  color: ${props => overloadColor(props.color)};
  opacity: ${props => props.opacity};
  font-size: ${props => props.size};
  cursor: ${props => props.cursor};

  ${props =>
    (props.translateX || props.translateY) &&
    css`
      transform: translate(
        ${props.translateX ?? '0'},
        ${props.translateY ?? '0'}
      );
    `};

  &:hover {
    color: ${props => props.hoverColor && overloadColor(props.hoverColor)};
    opacity: ${props => props.hoverOpacity ?? props.opacity};
  }
`

export type IconType =
  | 'thin'
  | 'light'
  | 'regular'
  | 'solid'
  | 'brand'
  | 'duotone'
export interface IconProps extends BaseProps {
  icon: FontAwesomeIcon
  type?: IconType
  fixedWidth?: boolean
  swapOpacity?: boolean

  title?: string
  color?: string
  hoverColor?: string
  opacity?: number
  hoverOpacity?: number
  cursor?: CSSCursor

  size?: string
  margin?: string
  translateX?: string
  translateY?: string

  onClick?: (event: React.MouseEvent<HTMLElement>) => void
}

export const Icon: React.FC<IconProps> = ({
  className,
  icon,
  type = 'regular',
  fixedWidth = false,
  swapOpacity = false,

  title,
  color = 'inherit',
  hoverColor,
  opacity = 1,
  hoverOpacity,
  cursor = 'inherit',

  size = '1em',
  margin = '0',
  translateX,
  translateY,

  onClick = () => void 0,
}) => {
  const iconClass = useMemo(
    () =>
      `${getIconTypeClassName(type)} fa-${icon} ${fixedWidth ? 'fa-fw' : ''} ${
        swapOpacity ? 'fa-swap-opacity' : ''
      } ${className ?? ''}`,
    [type, icon, fixedWidth, className, swapOpacity]
  )
  return (
    <I
      className={iconClass}
      title={title}
      color={color}
      hoverColor={hoverColor}
      opacity={opacity}
      hoverOpacity={hoverOpacity}
      cursor={cursor}
      size={size}
      margin={margin}
      translateX={translateX}
      translateY={translateY}
      onClick={onClick}
    />
  )
}
